import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { HaveFinish, PriceKey } from 'utils/finishes';
import { NoPriceCode } from 'utils/price';

interface CalculatePriceCard {
  wantListId: number;
  cardId?: string;  // Specific card ID for exact version matching
  condition: string;
  language: string;
  /** Authoritative (Track D); sent with the derived `foil` through D */
  finish?: HaveFinish;
  foil: boolean;
  set?: string;
}

interface CalculatePriceRequest {
  cards: CalculatePriceCard[];
}

interface CalculatePriceResponse {
  cards: Array<{
    wantListId: number;
    /**
     * Null when the card has no price (the slot then carries `code`). A request
     * for a single no-price card is a 400 with the same code instead. Never
     * trust a 0 here either: read it through hasRealPrice.
     */
    displayPrice: number | null;
    code?: NoPriceCode;
    languageMultiplierApplied?: boolean;
    multiplierValue?: number;
    /** The Price column used (backend Track A); null when no price resolved (the unitPrice 0 case). */
    priceKey?: PriceKey | null;
    /** Echoed finish (Track D) */
    finish?: HaveFinish;
  }>;
}

export const tradePriceApi = createApi({
  reducerPath: 'tradePriceApi',
  baseQuery,
  endpoints: (builder) => ({
    calculatePrice: builder.mutation<CalculatePriceResponse, CalculatePriceRequest>({
      query: (data) => ({
        url: '/trades/calculate-price',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useCalculatePriceMutation } = tradePriceApi;